export const CultureName = {
  English: "en-GB",
  Danish: "da-DK",
  German: "de-DE",
};
